module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid6.9d2d1f7d.png";